import { DatePipe } from "@angular/common";

export class DataUtil {

    public static zerarHora(data: Date | undefined | null) {
        if (data && typeof data !== 'string') {
            data.setHours(0);
            data.setMinutes(0);
            data.setSeconds(0);
        }
    }

    public static getDataNDiasAtrasComHoraZerada(numDias: number): Date {
        const data: Date = new Date();
        data.setDate(new Date().getDate() - numDias);
        data.setHours(0);
        data.setMinutes(0);
        data.setSeconds(0);
        return data;
    }

    public static compareDate(date1: Date | null | undefined, date2: Date | null | undefined): number {
        if (!date1 && !date2) {
            return 0;
        }
        if (!date1 && date2) {
            return -1;
        }
        if (date1 && !date2) {
            return 1;
        }
        if (date1 && date2) {
            if (date1 > date2) {
                return 1;
            } 
            if (date1 < date2) {
                return -1;
            } 
        }
        return 0;
    }

    public static compareDateStr(dateStr1: string, dateStr2: string): number {
        const data1 = DataUtil.parseStrToDate(dateStr1);
        const data2 = DataUtil.parseStrToDate(dateStr2);
        return DataUtil.compareDate(data1, data2);
    }

    /**
     * Espera formato DD/MM/YYYY
     */
    public static parseStrToDate(dateStr: string): Date | null {
        
        if (!dateStr || dateStr.length != 10) {
            return null;
        }
        const [day, month, year] = dateStr.split('/');
        return new Date(+   year, +month - 1, +day);
    }

    public static compareDateTimeStr(dateStr1: string, dateStr2: string): number {
        const data1 = DataUtil.parseStrToDateTime(dateStr1);
        const data2 = DataUtil.parseStrToDateTime(dateStr2);
        return DataUtil.compareDate(data1, data2);
    }

    /**
     * Espera formato DD/MM/YYYY HH:MM
     */
    public static parseStrToDateTime(dateStr: string): Date | null {
        
        if (!dateStr || dateStr.length != 16) {
            return null;
        }
        const [data, tempo] = dateStr.split(' ');
        const [month, day, year] = data.split('/');
        const [hour, minute] = tempo.split(':');

        return new Date(+year, +month - 1, +day, +hour, +minute);
    }

    static addDias(date: Date, dias: number): Date {
        const newDate = new Date(date);
        newDate.setUTCDate(newDate.getUTCDate() + dias);
        return newDate;
    }

    public static dateToStr(date: Date): string | null {
        const datePipe = new DatePipe("en-US");
        return datePipe.transform(date, 'dd/MM/yyyy');
    }

    public static dateAndTimeToStr(date: Date): string | null {
        const datePipe = new DatePipe("en-US");
        let str = datePipe.transform(date, 'dd/MM/yyyy HH:mm');
        if (str) {
            str = str.replaceAll(':', 'h');
        }
        return str;
    }

    public static dateToStrPorExtenso(date: Date): string | null {
        const datePipe = new DatePipe("pt-BR");
        return datePipe.transform(date, "dd 'de' MMMM 'de' yyyy");
    }

    public static getDataStrHoje(): string {
        const hoje = new Date();
        const ano = hoje.getFullYear();
        const mes = String(hoje.getMonth() + 1).padStart(2, '0');
        const dia = String(hoje.getDate()).padStart(2, '0');
        return `${ano}-${mes}-${dia}`;
    }

    public static getDataStr(date: Date | undefined): string {
        if (date instanceof Date) {
            const ano = date.getFullYear();
            const mes = String(date.getMonth() + 1).padStart(2, '0');
            const dia = String(date.getDate()).padStart(2, '0');
            return `${ano}-${mes}-${dia}`;
        } else if (date) {
            return date;
        } else {
            return "";
        }
    }
}